import { api, saveTokenAuthentication } from '../../services/api';
import {
  EMPTY_ERROR,
  GET_USER_FAILURE,
  GET_USER_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_LOADING_USER,
  SET_TOKEN,
  SIGN_UP_FAILURE,
  SIGN_UP_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
} from '../reducers/types';

export const setToken = (token) => async (dispatch) => {
  saveTokenAuthentication(token);
  dispatch({
    type: SET_TOKEN,
    token,
  });
};

export const loginUser = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING_USER });
    const response = await api.post('/login', credentials);
    saveTokenAuthentication(response.data.paciente.token);
    dispatch({ type: LOGIN_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: LOGIN_FAILURE, payload: error });
  }
};

export const loginWithDNI = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING_USER });
    const response = await api.post('/dni_login', credentials);
    saveTokenAuthentication(response.data.paciente.token);
    dispatch({ type: LOGIN_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: LOGIN_FAILURE, payload: error });
  }
};

export const emptyError = () => async (dispatch) => {
  dispatch({
    type: EMPTY_ERROR,
  });
};

export const registerUser = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING_USER });
    const response = await api.post('/registro', credentials);
    dispatch({ type: SIGN_UP_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: SIGN_UP_FAILURE, payload: error });
  }
};

export const logout = () => (dispatch) => dispatch({
  type: LOGOUT,
});

export const getUser = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING_USER });
    const response = await api.get('/perfil');
    dispatch({ type: GET_USER_SUCCESS, payload: response.data.paciente });
  } catch (error) {
    dispatch({ type: GET_USER_FAILURE, payload: error });
  }
};

export const updateUser = (user) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING_USER });
    const {
      nombre,
      telefono,
      apellido,
      email,
      dni,
      newPassword,
      currentPassword,
      token
    } = user;
    const params = {
      nombre,
      apellido,
      telefono,
      dni,
      email,
      password: newPassword,
      current_password: currentPassword,
      fcm_token: token,
    };
    const response = await api.post('/registro/editar', params);
    dispatch({ type: UPDATE_USER_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: UPDATE_USER_FAILURE, payload: error });
  }
};
